export default __webpack_public_path__ + "static/therapy_app-56ea83e85e9c943be3ef4347fe0e4f7f.png";